import { api, endpoints } from "../api";
import { AxiosPromise } from "axios";

export const TRAINER_AVAILABILITY_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
} as const;

export type TrainerAvailabilityStatus = (typeof TRAINER_AVAILABILITY_STATUS)[keyof typeof TRAINER_AVAILABILITY_STATUS];

export interface TrainerAvailabilityRangeApi {
  id: number;
  startDate: Date;
  endDate: Date;
  status: TrainerAvailabilityStatus;
  comment?: string;
}

export interface TrainerAvailabilityDataApi {
  ranges: TrainerAvailabilityRangeApi[];
  sessionDays: Date[];
}

export interface TrainerAvailabilityRequestApi {
  id: number;
  startDate: Date;
  endDate: Date;
  dueDate?: Date;
  comment?: string;
  isFulfilled: boolean;
}

export interface CreateTrainerAvailabilityRequestPayload {
  startDate: Date;
  endDate: Date;
  dueDate?: Date;
  comment?: string;
}

const fetchAvailability = (trainerId: number): AxiosPromise<TrainerAvailabilityDataApi> => {
  return api.get<TrainerAvailabilityDataApi>(endpoints.TRAINERS.GET_AVAILABILITY(trainerId));
};

const fetchAvailabilityRequests = (trainerId: number): AxiosPromise<TrainerAvailabilityRequestApi[]> => {
  return api.get<TrainerAvailabilityRequestApi[]>(endpoints.TRAINERS.GET_AVAILABILITY_REQUESTS(trainerId));
};

const createAvailabilityRequest = (
  trainerId: number,
  data: CreateTrainerAvailabilityRequestPayload,
): AxiosPromise<void> => {
  return api.post<void>(endpoints.TRAINERS.CREATE_AVAILABILITY_REQUEST(trainerId), data);
};

const cancelAvailabilityRequest = (trainerId: number, requestId: number): Promise<void> => {
  return api.delete(endpoints.TRAINERS.CANCEL_AVAILABILITY_REQUEST(trainerId, requestId));
};

export const trainerAvailabilityApi = {
  fetchAvailability,
  fetchAvailabilityRequests,
  createAvailabilityRequest,
  cancelAvailabilityRequest,
};
